import { UIText1, Label } from '@cian/ui-kit';
import * as React from 'react';
import { formatDiscount, formatMoney } from '../../../../utils/string';
import * as styles from './Discount.css';

interface IDiscountProps {
  discountPercent: number;
  marketingPrice: number;
}

export const Discount = (props: IDiscountProps) => {
  const { discountPercent, marketingPrice } = props;

  return (
    <div className={styles['discount_wrapper']}>
      <div className={styles['price_without_discount']}>
        <UIText1>{formatMoney(marketingPrice)}</UIText1>
      </div>

      <Label color="error_100" background="error_10">
        {formatDiscount(discountPercent)}
      </Label>
    </div>
  );
};
